import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';
import { PillarActionItem } from '../PillarActionItem';

export const ActionItemList = ({
  pillarResource,
  collection: actionItemsCollection,
  onClickActionItem,
  prePlan,
}) => {
  const actionItems = React.useMemo(() => {
    return actionItemsCollection.resources().list().filter((v, i) => (i !== 0));
  }, [actionItemsCollection]);

  if (actionItems.length === 0) {
    return null;
  }

  return (
    <FDStack direction={'column'} paddingX={1} spacing={2}>
      {actionItems.map((resource) => {
        return (<PillarActionItem
          pillarResource={pillarResource}
          resource={resource}
          key={resource.id()}
          onClick={onClickActionItem}
          prePlan={prePlan}
        />);
      })}
    </FDStack>
  );
};

ActionItemList.defaultProps = {
};

ActionItemList.propTypes = {
  pillarResource: PropTypes.object.isRequired,
  onClickActionItem: PropTypes.func.isRequired,
  collection: PropTypes.object.isRequired,
  prePlan: PropTypes.bool.isRequired,
};
